// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ProjectModel } from '../model/project.model';
import { DeleteCodingArticleProcessor } from '../components/article/processor/delete-coding-article.processor';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from './detach-article-usage.service';
import { ProjectUtils } from '../components/project/util/project-utils';

@Injectable({providedIn: 'root'})
export class AttachArticleUsageService {
    constructor(
        private projectModel: ProjectModel,
        private deleteCodingArticleProcessor: DeleteCodingArticleProcessor,
        private applicationRefreshService: ApplicationRefreshService,
        private detachArticleUsageService: DetachArticleUsageService
    ) {}

    public async attachArticleUsageToProject(usage: ArticleUsageVO, compositionId: string = null, forceRefresh: boolean = true): Promise<void> {
      if (!compositionId) {
        // attach to first one
        ProjectUtils.getFirstArticleUsages(this.projectModel.currentProject).push(usage);
      } else {
        const composition = ProjectUtils.findCompositionById(this.projectModel.currentProject, compositionId);
        if(composition) {
          composition.articleUsages.push(usage);
          await this.deleteCodingArticleProcessor.deleteCodingFingerIfNecessary(usage, composition);
        }
      }
      if (this.deleteCodingArticleProcessor.isArticleUsageMarkedForDeletion(usage.id)) {
        this.deleteCodingArticleProcessor.unMarkArticleUsageForDeletion(usage.id);
        await this.detachArticleUsageService.internalDetachArticleUsageFromProjectById(usage.id, false);
      }
      if (forceRefresh) {
        await this.applicationRefreshService.refreshProject();
      }
    }
}
